import { Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';

@Component({
    selector: 'app-ai-features-usage-renderer',
    templateUrl: './ai-features-usage-renderer.component.html',
    styleUrls: ['./ai-features-usage-renderer.component.scss'],
    standalone: false,
})
export class AiFeaturesUsageRendererComponent implements ICellRendererAngularComp {
    private readonly rawValue = signal<number | null>(null);

    protected readonly isLoading = computed(() => this.rawValue() === null);
    protected readonly displayValue = computed(() => this.rawValue() ?? 0);
    protected readonly barValue = computed(() => Math.min(this.displayValue(), 100));

    protected readonly colorClass = computed((): 'warning' | 'danger' | '' => {
        const value = this.displayValue();
        if (value >= 98) return 'danger';
        if (value >= 75) return 'warning';
        return '';
    });

    agInit(params: ICellRendererParams & { customTooltipMessage: string | undefined }): void {
        this.setValues(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.setValues(params);
        return true;
    }

    private setValues(params: any): void {
        this.rawValue.set(params.valueFormatted === null ? null : (params.valueFormatted ?? 0));
    }
}
